export default "__VITE_ASSET__L7K7vuts__"